"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BackupSelect;
var _styles = require("@mui/styles");
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel/InputLabel.js"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl/FormControl.js"));
var _Select = _interopRequireDefault(require("@mui/material/Select/Select.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  divcontrol: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  label: {
    display: 'flex',
    fontWeight: 'bold'
  }
}));
function BackupSelect({
  schedules,
  selectedSchedule,
  onClickSelect
}) {
  const classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: classes.divcontrol,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
        className: classes.label,
        children: "Select a Backup Schedule :"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl.default, {
        className: classes.formControl,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
          value: selectedSchedule.Id,
          onChange: e => onClickSelect(e.target.value),
          variant: "outlined",
          size: "small",
          children: schedules?.map(item => {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
              value: item.Id,
              children: item.Name
            }, item.Id);
          })
        })
      })]
    })
  });
}